export default __webpack_public_path__ + "static/media/wi-night-partly-cloudy.86d0f018.svg";